import { useCallback } from 'react';
import { Box } from '@creditas-ui/react';
import { useGetPosts } from '@/hooks/queries/useGetPosts';
import { redirect } from '@/utils/redirect';
import { Slider } from '@/components/Slider';
import { dispatchBlogArticleEvent } from '@/utils/analyticsEvents';
import { SectionTitle } from '@/components/SectionTitle';
import i18n from '@/i18n';
import { CardBlog } from './CardBlog';

type BlogSectionProps = {
  link: string;
  title: string;
  index: number;
};

const BlogSection = (): JSX.Element => {
  const { isSuccess, data } = useGetPosts();
  const handleCardClick = useCallback(
    ({ link, title, index }: BlogSectionProps) =>
      (): void => {
        dispatchBlogArticleEvent(`${index} | ${title}`);
        redirect(link);
      },
    [],
  );

  return (
    <Box>
      <SectionTitle>{i18n.t('blog:content.title')}</SectionTitle>

      {isSuccess && (
        <Slider>
          {(data || []).map(({ id, link, ...post }, index) => (
            <CardBlog
              key={id}
              {...post}
              onClick={handleCardClick({ link, title: post.title, index })}
            />
          ))}
        </Slider>
      )}
    </Box>
  );
};

export { BlogSection };
